const COMBINING_DIACRITICS_START = 0x0300;
const COMBINING_DIACRITICS_END = 0x036f;
const DIACRITICS_PATTERN = new RegExp(
  `[${String.fromCharCode(COMBINING_DIACRITICS_START)}-${String.fromCharCode(COMBINING_DIACRITICS_END)}]`,
  'g'
);

/**
 * Only for telling two names of the same request apart inside the modal. It is never the answer to
 * whether a name is already taken: the database folds more than a combining-mark strip does (ß
 * reads as ss, ø as o), so a normalization written here would answer a question the server answers
 * differently.
 */
export function normalizeSettingsText(value: string): string {
  return value.trim().normalize('NFD').replace(DIACRITICS_PATTERN, '').toLocaleLowerCase('pt-BR');
}
